export default __webpack_public_path__ + "static/media/nublado.86fbc252.gif";